import { useContext } from "react";
import { ReactReduxContext } from "react-redux";
import { seesCustomerDetails, seesOrderPrices } from "./storeAccess";

// What the signed-in user sees of orders: prices and amounts ("View price")
// and the customer's phone and email ("View customer details"). The server
// sends hidden fields blank; the screens leave their columns and labels out.
// Read from the store when there is one (some screens are tested without it):
// no signed-in user means no limits, as before.
export const useOrderVisibility = () => {
  const context = useContext(ReactReduxContext);
  const user = context?.store?.getState?.()?.user;
  return {
    showPrices: seesOrderPrices(user),
    showContact: seesCustomerDetails(user),
    // The signed-in user, for the other role checks (storeAccess).
    user,
  };
};
